/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Chat_PlaceholderInputs */

const en_us2_clubs_chat_placeholder = /** @type {(inputs: Clubs_Chat_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write to the club`)
};

const pt_br2_clubs_chat_placeholder = /** @type {(inputs: Clubs_Chat_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escreva para o clube`)
};

const es_419_clubs_chat_placeholder = /** @type {(inputs: Clubs_Chat_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escribe al club`)
};

const pt_pt2_clubs_chat_placeholder = /** @type {(inputs: Clubs_Chat_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escreve para o clube`)
};

const fr_fr2_clubs_chat_placeholder = /** @type {(inputs: Clubs_Chat_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Écris au club`)
};

const de_de2_clubs_chat_placeholder = /** @type {(inputs: Clubs_Chat_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schreib an den Club`)
};

const it_it2_clubs_chat_placeholder = /** @type {(inputs: Clubs_Chat_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scrivi al club`)
};

/**
* | output |
* | --- |
* | "Write to the club" |
*
* @param {Clubs_Chat_PlaceholderInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_chat_placeholder = /** @type {((inputs?: Clubs_Chat_PlaceholderInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Chat_PlaceholderInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_chat_placeholder(inputs)
	if (locale === "es-419") return es_419_clubs_chat_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_chat_placeholder(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_chat_placeholder(inputs)
	if (locale === "de-DE") return de_de2_clubs_chat_placeholder(inputs)
	if (locale === "it-IT") return it_it2_clubs_chat_placeholder(inputs)
	return en_us2_clubs_chat_placeholder(inputs)
});
export { clubs_chat_placeholder as "clubs.chat_placeholder" }